import { ResponseType } from "../../../Types/ServicesType/servicesType";
import {
  MasterDataType,
  MasterTableDataType,
  SaveResponseType,
  SearchParamsType,
} from "./Types";
import api from "@services/apiList";
import instance from "@services/services";
const { MastersApi } = api;
export const getMastersTableData = async (
  params: SearchParamsType
): Promise<
  ResponseType<{ totalCount: number; items: MasterTableDataType[] }>
> => {
  const result = await instance.post(
    `${MastersApi.getInsurancePlanTableData}`,
    params
  );
  return result.data;
};

export const saveMasterData = async (
  params: MasterDataType[]
): Promise<ResponseType<SaveResponseType>> => {
  const result = await instance.post(
    `${MastersApi.saveInsurancePlanData}`,
    params
  );
  return result.data;
};

export const deleteInsurancepalnid = async (params:
{  inPlanId: number,
  clinicId: number}
): Promise<ResponseType<SaveResponseType>> => {
    const result = await instance.delete(
    `${MastersApi.deleteInsuranceType}/${params.clinicId}?inplanid=${params.inPlanId}`,
  );
  return result.data;
};


